import _NewActionForm from './NewActionForm'
const _NewAction = () => {
  
    const content = <_NewActionForm  />

    return content
}
export default _NewAction